import React from 'react';
import { connect } from 'react-redux';

const quillLogoSrc = `${window.postbuildEnv.CDN_URL}/images/logos/quill-logo-white.svg`

const handleLogoClick = () => {
  if (window.confirm('Are you sure you want to leave your lesson?')) {
    window.location = window.postbuildEnv.DEFAULT_URL;
  }
}

export const Navbar = ({ classroomSessions, customize, counterText: counterTextOverride, }) => {
  // The counter can be supplied directly (e.g. by the slide-editor preview);
  // otherwise it's derived from the live session + edition in the store.
  let counterText = counterTextOverride
  if (counterText === undefined) {
    const data = classroomSessions ? classroomSessions.data : {}
    // need to subtract one from the number of questions to account for the lobby slide
    const numberOfQuestions = customize && customize.editionQuestions && customize.editionQuestions.questions ? customize.editionQuestions.questions.length - 1 : null
    counterText = numberOfQuestions ? `${data.current_slide} of ${numberOfQuestions}` : ''
  }

  return (
    <header className='nav student-nav'>
      <nav className="student-lessons">
        <div className="brand">
          <button
            className="focus-on-dark interactive-wrapper"
            onClick={handleLogoClick}
            type="button"
          >
            <img
              alt="Quill.org logo"
              className="quill-logo"
              src={quillLogoSrc}
            />
          </button>
          <span className="lessons-badge">Lessons</span>
        </div>
        <p className="counter">{counterText}</p>
      </nav>
    </header>
  );
}

function select(props) {
  return {
    classroomSessions: props.classroomSessions,
    customize: props.customize,
  };
}

export default connect(select)(Navbar);
